import React, { useState, useEffect, useRef } from 'react';
import { api } from 'common';
import { useTranslation } from "react-i18next";
import langlocales from '../lists/langlocales';
import datelocales from '../lists/datelocales';
import MaterialTable from 'material-table';
import { useSelector, useDispatch } from "react-redux";
import BookIcon from '@mui/icons-material/Book';
import {
  Typography,
  Modal,
  Button,
  Grid
} from '@mui/material';
import CircularLoading from 'components/CircularLoading';
import { makeStyles } from '@mui/styles';
import TextField from '@mui/material/TextField';
import { colors, modernColors } from '../components/Theme/WebTheme';
import { FONT_FAMILY, downloadCsv } from '../common/sharedFunctions';
import {FirebaseConfig} from '../config/FirebaseConfig';
import {SECONDORY_COLOR } from "../common/sharedFunctions";
import { MAIN_COLOR } from '../common/sharedFunctions';
import { ThemeProvider } from '@mui/material/styles';
import theme from "styles/tableStyle";
import TextFieldsIcon from '@mui/icons-material/TextFields';

const useStyles = makeStyles((theme) => ({
  modal: {
    display: 'flex',
    padding: theme.spacing(1),
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    width: 850,
    backgroundColor: theme.palette.background.paper,
    border: `1px solid ${modernColors.border}`,
    borderRadius: '8px',
    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
    padding: theme.spacing(2, 4, 3),
    overflow:'auto',
    maxHeight: '80vh'
  },
  paper2: {
    width: 250,
    backgroundColor: theme.palette.background.paper,
    border: `1px solid ${modernColors.border}`,
    borderRadius: '8px',
    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
    padding: theme.spacing(2, 4, 3),
    overflow:'initial'
  },
  editButton: {
    backgroundColor: modernColors.primary,
    color: 'white',
    fontFamily: FONT_FAMILY,
    fontWeight: 500,
    fontSize: '0.875rem',
    textTransform: 'none',
    padding: '6px 16px',
    borderRadius: '6px',
    boxShadow: 'none',
    '&:hover': {
      boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
      backgroundColor: `${modernColors.primary}e0`
    }
  },
  keyInput: {
    marginBottom: '16px',
    width: '100%',
    "& .MuiInputBase-root": {
      fontFamily: FONT_FAMILY
    }
  },
  actionButtons: {
    marginTop: '24px',
    display: 'flex',
    justifyContent: 'flex-end',
    gap: '12px'
  }
}));

export default function LanguageSetting(props) {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.dir();
  const {
    editLanguage
  } = api;
  const rootRef = useRef(null);
  const [open, setOpen] = useState(false);
  const [rowIndex, setRowIndex] = useState();
  const classes = useStyles();
  const [data, setData] = useState();
  const languagedata = useSelector(state => state.languagedata);
  const dispatch = useDispatch();
  const settings = useSelector(state => state.settingsdata.settings);
  const [keyValuePair, setKeyValuePair] = useState();
  const [completed,setCompleted] = useState(0);
  const [enSet,setEnSet] = useState();
  const [openLoader, setOpenLoader] = useState(false);
  const [isLoading, setIsLoading] = useState(false)

  const columns = [
    { 
      title: t('langName'), 
      field: 'langName',  
    },
    {
      title: t('langLocale'),
      field: 'langLocale',
      lookup: langlocales,
    },
    {
      title: t('dateLocale'),
      field: 'dateLocale',
      lookup: datelocales, 
    }
  ];

  useEffect(() => {
    if (languagedata.langlist) {
      setData(languagedata.langlist);
    } else {
      setData([]);
    }
  }, [languagedata.langlist, enSet]);


  const handleClose = () => {
    setKeyValuePair(null);
    setRowIndex(-1);
    setOpen(false);
  }

  const handleLoaderClose = () => {
    setCompleted(0);
    setOpenLoader(false);
  }

  const saveJson = () => {
    let newData = data[rowIndex];
    try {
      if (settings.AllowCriticalEditsAdmin) {
        let obj = {};
        for(let i=0;i< keyValuePair.length; i++){
          obj[keyValuePair[i][0]] = keyValuePair[i][1];
        }
        newData['keyValuePairs'] = obj;
        dispatch(editLanguage(newData, "Update"));
        handleClose();
      } else {
        alert(t('demo_mode'));
      }
    } catch (error) {
      alert("JSON Error"); 
    }
  }

  useEffect(()=>{
    if(keyValuePair && keyValuePair.length> 0){
      setOpen(true);
      setIsLoading(false)
    }else{
      setOpen(false);
    }
  },[keyValuePair])

  const [selectedRow, setSelectedRow] = useState(null);

  const handleEditjson = (rowData)=>{
    setIsLoading(true)
    setRowIndex(rowData.tableData.id);
    setKeyValuePair(Object.entries(data[rowData.tableData.id].keyValuePairs));
  }
  
  const handleChange = (e, index, field) => {
    let kvPairs = [...keyValuePair];
    if(field === 'key'){
      kvPairs[index][0] = e.target.value;
    } else{
      kvPairs[index][1] = e.target.value;
    }
    setKeyValuePair(kvPairs);
  };

  return (
    languagedata.loading || isLoading?
      <CircularLoading /> :
      <div>
        <ThemeProvider theme={theme}>
          <MaterialTable
            title={t('language_cap')}
            columns={columns}
            style={{
              direction: isRTL === 'rtl' ? 'rtl' : 'ltr',
              borderRadius: "8px",
              boxShadow: '0 2px 8px rgba(0, 0, 0, 0.05)',
              padding: "20px",
              fontFamily: FONT_FAMILY
            }}
            data={data}
            onRowClick={((evt, selectedRow) => setSelectedRow(selectedRow.tableData.id))}
            options={{
              pageSize: 10,
              pageSizeOptions: [10, 15, 20],
              exportCsv: (columns, data) => {
                let hArray = [];
                const headerRow = columns.map(col => {
                  if (typeof col.title === 'object') {
                    return col.title.props.text;
                  }
                  hArray.push(col.field);
                  return col.title;
                });
                const dataRows = data.map(({ tableData, ...row }) => {
                  row.createdAt = new Date(row.createdAt).toLocaleDateString() + ' '+ new Date(row.createdAt).toLocaleTimeString()
                  let dArr = [];
                  for(let i=0;i< hArray.length; i++) {
                    dArr.push(row[hArray[i]]);
                  }
                  return Object.values(dArr);
                })
                const { exportDelimiter } = ",";
                const delimiter = exportDelimiter ? exportDelimiter : ",";
                const csvContent = [headerRow, ...dataRows].map(e => e.join(delimiter)).join("\n");
                const csvFileName = 'download.csv';
                downloadCsv(csvContent, csvFileName);
              },
              exportButton: {
                csv: settings.AllowCriticalEditsAdmin,
                pdf: false,
              },
              maxColumnSort: "all_columns",
              rowStyle: rowData => ({
                backgroundColor: selectedRow === rowData.tableData.id ? `${modernColors.primary}15` : modernColors.background,
                transition: 'all 0.2s ease',
                '&:hover': {
                  backgroundColor: modernColors.hover
                }
              }),
              headerStyle: {
                position: "sticky",
                top: "0px",
                fontSize: '0.875rem',
                fontWeight: 600,
                color: modernColors.textPrimary,
                backgroundColor: modernColors.headerBg,
                textAlign: "center",
                padding: '16px',
                borderBottom: `1px solid ${modernColors.border}`
              },
              cellStyle: {
                borderBottom: `1px solid ${modernColors.border}`,
                textAlign: "center",
                padding: '16px 8px',
                fontSize: '0.875rem'
              },
              actionsColumnIndex: -1,
            }}
            localization={{
              body:{
                addTooltip: (t('add')),
                deleteTooltip: (t('delete')),
                editTooltip: (t('edit')),
                emptyDataSourceMessage: (t('blank_message')),
                editRow: { 
                  deleteText: (t('delete_message')),
                  cancelTooltip: (t('cancel')),
                  saveTooltip: (t('save')) 
                }, 
              },
              toolbar: {
                searchPlaceholder: (t('search')),
                exportTitle: (t('export')),
              },
              header: {
                actions: (t('actions')) 
              },
              pagination: {
                labelDisplayedRows: ('{from}-{to} '+ (t('of'))+ ' {count}'),
                firstTooltip: (t('first_page_tooltip')),
                previousTooltip: (t('previous_page_tooltip')),
                nextTooltip: (t('next_page_tooltip')),
                lastTooltip: (t('last_page_tooltip'))
              },
            }}
            editable={{
              onRowAdd: settings.AllowCriticalEditsAdmin ?
                newData =>
                  new Promise(resolve => {
                    setTimeout(() => {
                      resolve();
                      if (settings.AllowCriticalEditsAdmin) {
                        if (newData.langName && newData.langLocale && newData.dateLocale) {
                          delete newData.tableData;
                          newData.keyValuePairs = {};
                          dispatch(editLanguage(newData, "Add"));
                        } else {
                          alert(t('no_details_error'));
                        }
                      } else {
                        alert(t('demo_mode'));
                      }
                    }, 600);
                  })
                :
                null,
              onRowDelete: settings.AllowCriticalEditsAdmin ?
                oldData =>
                  new Promise(resolve => {
                    setTimeout(() => {
                      resolve();
                      dispatch(editLanguage(oldData, "Delete"));
                    }, 600);
                  })
                :
                null,
              onRowUpdate:(newData, oldData) =>
                new Promise(resolve => {
                  setTimeout(() => {
                    resolve();
                    if (settings.AllowCriticalEditsAdmin) {
                      delete newData.tableData;
                      dispatch(editLanguage(newData, "Update"));
                    } else {
                      alert(t('demo_mode'));
                    }
                  }, 600);
                }),
            }}
            actions={[
              {
                icon: () => (
                  <Button 
                    variant="contained" 
                    className={classes.editButton}
                    size="small"
                    startIcon={<TextFieldsIcon />}
                  >
                    {t('edit_translations')}
                  </Button>
                ),
                tooltip: t('edit_translations'),
                onClick: (event, rowData) => handleEditjson(rowData)
              }
            ]}
          />
        </ThemeProvider>
        <Modal
          disablePortal
          disableEnforceFocus
          disableAutoFocus
          open={open}
          onClose={handleClose}
          className={classes.modal}
          container={() => rootRef.current}
        >
          <div className={classes.paper}>
            <Typography variant="h6" style={{marginBottom: '20px', fontFamily: FONT_FAMILY}}>
              {t('edit_translations')}
            </Typography>
            {keyValuePair && keyValuePair.length > 0 ? 
              keyValuePair.map((item, index) => (
                <Grid container spacing={2} key={index}>
                  <Grid item xs={12} sm={4}>
                    <TextField
                      className={classes.keyInput}
                      label={t('key')}
                      variant="outlined"
                      value={item[0]}
                      onChange={(e) => handleChange(e, index, 'key')}
                      disabled={true}
                      InputProps={{
                        style: { fontFamily: FONT_FAMILY }
                      }}
                      InputLabelProps={{
                        style: { fontFamily: FONT_FAMILY }
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={8}>
                    <TextField
                      className={classes.keyInput}
                      label={t('value')}
                      variant="outlined"
                      value={item[1]}
                      onChange={(e) => handleChange(e, index, 'value')}
                      InputProps={{
                        style: { fontFamily: FONT_FAMILY }
                      }}
                      InputLabelProps={{
                        style: { fontFamily: FONT_FAMILY }
                      }}
                    />
                  </Grid>
                </Grid>
              ))
              : null
            }
            <div className={classes.actionButtons}>
              <Button
                onClick={handleClose}
                variant="outlined"
                style={{
                  fontFamily: FONT_FAMILY,
                  textTransform: 'none',
                  color: modernColors.error,
                  borderColor: modernColors.error
                }}
              >
                {t('cancel')}
              </Button>
              <Button
                onClick={saveJson}
                variant="contained"
                style={{
                  backgroundColor: modernColors.success,
                  color: 'white',
                  fontFamily: FONT_FAMILY,
                  textTransform: 'none'
                }}
              >
                {t('save')}
              </Button>
            </div>
          </div>
        </Modal>
      </div>
  );
}
